<template>
  <div
    class="col-lg-9 col-sm-12 color-dashboard-background grid_combo_item_content"
  >
    <div class="row">
      <div
        class="col-md-4 col-sm-6 foodbox_container"
        v-for="(item, index) in subItems"
        :class="{
          active_right_combo: activeOnClick.includes(
            item._id + selectedContainerId
          ),
        }"
        :key="index"
        @click="setActiveItems(item)"
      >
        <div class="foodbox_item">
          <div class="food-item-box">
            <img :src="item.image" alt v-if="item.image != ''" />
            <img
              v-else
              style="border:$px1 solid rgba($black, 0.44);"
              :style="{
                background:
                  item.image == '' && item.item_color
                    ? item.item_color
                    : 'white',
              }"
            />
            <div class="food-menu-item-text color-text">
              <label :title="_T_DB(item, 'name')">
                {{ _T_DB(item, 'name') }}
              </label>
            </div>
          </div>
          <div class="food-box-icon">
            <!--<i
          class="fa fa-check item-selected-check right_icon"
          aria-hidden="true"
        ></i>-->
            <b-iconstack font-scale="2" class="item-selected-check right_icon">
              <b-icon stacked icon="square-fill" variant="danger"></b-icon>
              <b-icon stacked icon="square" variant="danger"></b-icon>
              <b-icon stacked icon="check" scale="1" variant="white"></b-icon>
            </b-iconstack>
            <b-iconstack
              font-scale="2.1"
              @click="setModifiersForItem(item)"
              class="combo-plus-icon"
            >
              <b-icon stacked icon="circle-fill" variant="danger"></b-icon>
              <b-icon stacked icon="plus" scale="1" variant="white"></b-icon>
              <b-icon stacked icon="circle" variant="danger"></b-icon>
            </b-iconstack>
            <!--<div
          class="button-plus"
          data-toggle="modal"
        >
          <div class="button-plus-icon">
            <svg
              class="color-text"
              viewBox="0 0 15 15"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.40002 6.3999V1.3999C8.40002 1.13469 8.29467 0.880332 8.10713 0.692796C7.9196 0.505259 7.66524 0.399902 7.40002 0.399902C7.13481 0.399902 6.88045 0.505259 6.69292 0.692796C6.50538 0.880332 6.40002 1.13469 6.40002 1.3999V6.3999H1.40002C1.13481 6.3999 0.880454 6.50526 0.692918 6.6928C0.505381 6.88033 0.400024 7.13469 0.400024 7.3999C0.400024 7.66512 0.505381 7.91947 0.692918 8.10701C0.880454 8.29455 1.13481 8.3999 1.40002 8.3999H6.40002V13.3999C6.40002 13.6651 6.50538 13.9195 6.69292 14.107C6.88045 14.2945 7.13481 14.3999 7.40002 14.3999C7.66524 14.3999 7.9196 14.2945 8.10713 14.107C8.29467 13.9195 8.40002 13.6651 8.40002 13.3999V8.3999H13.4C13.6652 8.3999 13.9196 8.29455 14.1071 8.10701C14.2947 7.91947 14.4 7.66512 14.4 7.3999C14.4 7.13469 14.2947 6.88033 14.1071 6.6928C13.9196 6.50526 13.6652 6.3999 13.4 6.3999H8.40002Z"
              />
            </svg>
          </div>
        </div>-->
          </div>
        </div>
        <!--<div class="foodbox_price_cntr">
        &lt;!&ndash;<div class="food-menu-item-price">
          &lt;!&ndash;<strong>{{ formatPrice(item.value) }}</strong>&ndash;&gt;
        </div>&ndash;&gt;
      </div>-->
      </div>
    </div>
    <ComboModifiers />
  </div>
</template>

<script>
/*   eslint-disable no-console */
import { mapActions, mapGetters, mapState } from 'vuex'
import ComboModifiers from './Modifiers'
export default {
  name: 'ItemContent',
  components: { ComboModifiers },
  data () {
    return {
      activeItems: {},
      activeOnClick: [],
    }
  },
  watch: {
    activeComboItems (newVal, oldVal) {
      if (newVal != oldVal) {
        this.$nextTick(() => {
          if (Object.keys(this.activeComboItems).length === 0) {
            this.activeOnClick = []
          }
          this.commitErrorMessage('')
        })
      }
    },
  },
  computed: {
    ...mapState('combo_items_store', [
      'subItems',
      'selectedItemContainer',
      'activeComboItems',
    ]),
    ...mapGetters(['_T', '_T_DB']),
    ...mapState('context_store', ['current_store']),
    // ...mapGetters('modifier', ['stateItemModifiers', 'modifiers']),
    // ...mapGetters('auth', ['multistore']),
    ...mapState('cart_store', ['selectedModifiers']),
    ...mapGetters('combo_items_store', ['limitOfSelectingItems']),
    selectedContainerId () {
      return this.selectedItemContainer._id.$oid
    },
  },
  methods: {
    isActiveItem (itemId) {
      let activeItem = false
      let selectedContainerId = this.selectedContainerId
      if (typeof this.activeItems[selectedContainerId] != 'undefined') {
        this.activeItems[selectedContainerId].forEach(element => {
          if (element) {
            if (element._id === itemId) {
              if (!activeItem) activeItem = true
            }
          }
        })
      }
      return activeItem
    },
    ...mapActions('order', ['setActiveItem']),
    setActiveItems (item, modifiersAction = false) {
      let selectedContainerId = this.selectedItemContainer._id.$oid
      if (Object.keys(this.activeComboItems).length === 0) {
        console.log(this.activeComboItems)
        this.activeItems = {}
        this.activeItems[selectedContainerId] = []
      }
      let itemIndex = false
      let selectedLength = 0
      if (typeof this.activeItems[selectedContainerId] != 'undefined') {
        itemIndex = this.activeItems[selectedContainerId].find(
          activatedItem => activatedItem._id === item._id
        )
        selectedLength = this.activeItems[selectedContainerId].length
      } else {
        this.activeItems[selectedContainerId] = []
      }

      if (itemIndex && !modifiersAction) {
        let indexSubItem = this.activeItems[selectedContainerId].indexOf(
          itemIndex
        )
        this.activeItems[selectedContainerId].splice(indexSubItem, 1)
        this.activeOnClick.splice(
          this.activeOnClick.indexOf(item._id + selectedContainerId),
          1
        )
        this.commitErrorMessage('')
      } else {
        if (selectedLength != this.limitOfSelectingItems) {
          this.commitErrorMessage('')
          this.activeItems[selectedContainerId].push(item)
          this.activeOnClick.push(item._id + selectedContainerId)
          this.isActiveItem(item._id)
          if (this.$store.getters.hasModifiers(item)) {
            /*$('#POSItemOptions .modifier-option-radio').prop('checked', false)
            this.$store.dispatch('modifier/assignModifiersToItem', item)
            this.$store.commit('orderForm/clearSelection')
            showModal('#POSItemOptions')*/
            this.setModifiersForItem(item, false)
          } else {
            // this.$bvModal.hide('combo-modifiers')
          }
        } else {
          this.commitErrorMessage(
            `You can select only ${this.limitOfSelectingItems} item (s) from this section.`
          )
        }
      }
      this.$store.commit(
        'combo_items_store/ACTIVE_COMBO_ITEMS',
        this.activeItems,
        {
          root: true,
        }
      )
    },
    setModifiersForItem (item, shouldCheckActiveItem = true) {
      if (shouldCheckActiveItem) this.setActiveItems(item, true)
      // this.$store.commit('SET_ITEM_DETAIL_POPUP', true)
      // if (this.$store.getters['modifier/hasModifiers'](item)) {
      // this.$store.commit('modifier/SET_ITEM', item)
      this.$store.commit('SELECT_ITEM', item)
      this.$bvModal.show('combo-modifiers')
      // console.log('ittt', item, this.selectedModifiers)
      // this.$store.commit('SET_ITEM_DETAIL_POPUP', true)
      // $('#POSItemOptions .modifier-option-radio').prop('checked', false)
      // this.$store.dispatch('modifier/assignModifiersToItem', item)
      /*if (this.selectedItem.modifiers.find(obj => obj.itemId == item._id)) {
        //use updated modifiers
        // const modifiers = this.modifiers(item)

        /!*this.$store.commit('modifier/SET_ITEM_MODIFIERS', {
          itemId: item._id,
          modifiers: modifiers,
          item: item,
          multistore: this.multistore ? this.storeId : false,
        })*!/
      }*/
      // this.$bvModal.show('combo-modifiers')
      // }
    },
    commitErrorMessage (message) {
      this.$store.commit('combo_items_store/SET_ERROR_MESSAGE', message)
    },
  },
}
</script>

<style lang="scss" scoped>
.grid_combo_item_content {
  overflow: hidden;
  max-height: 21.875rem;
  overflow-y: auto;
}
.foodbox_container {
  position: relative;
  cursor: pointer;
  padding: 0 $px8;
  &.active_right_combo {
    .foodbox_item {
      border-color: $color-primary;
      .item-selected-check {
        display: block !important;
      }
    }
  }
  .foodbox_item {
    background: $white;
    border: $px1 solid rgba(var(--color-dark-border-source), 0.44);
    border-radius: $px4;
    overflow: unset;
    margin-bottom: $px16;
    position: relative;
    .food-item-box {
      text-align: center;
      img {
        max-height: 4.688rem;
        min-height: 4.688rem;
        min-width: 4.688rem;
        max-width: 4.688rem;
        margin: 0.325rem;
      }
      .food-menu-item-text {
        text-align: left;
        padding: $px10;
        margin: 0;
        padding-right: $px40;
        border-top: $px1 solid rgba(var(--color-dark-border-source), 0.44);
        label {
          font-size: $px12;
          line-height: $px15;
          letter-spacing: 0.5px;
          color: $font-color;
          margin-bottom: $px6;
          font-weight: bold;
          min-height: $px30;
          align-items: center;
          display: flex;
        }
      }
    }
    .food-box-icon {
      .b-iconstack {
        font-size: $px18 !important;
      }
      .combo-plus-icon {
        position: absolute;
        bottom: $px20;
        right: $px10;
      }
      .item-selected-check {
        position: absolute;
        top: 0;
        right: 0;
        display: none;
      }
    }
  }
}
.grid_combo_item_content::-webkit-scrollbar {
  display: none;
}
</style>
